import { render, staticRenderFns } from "./ReportArhiveObject.vue?vue&type=template&id=84a18534&scoped=true&"
import script from "./ReportArhiveObject.vue?vue&type=script&lang=js&"
export * from "./ReportArhiveObject.vue?vue&type=script&lang=js&"
import style0 from "./ReportArhiveObject.vue?vue&type=style&index=0&id=84a18534&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a18534",
  null
  
)

export default component.exports
import {QItemLabel,QExpansionItem,QChip,QAvatar,QIcon,QItem,QCard,QToolbar,QToolbarTitle,QTooltip,QKnob,QCardSection,QTable,QTr,QTd,Ripple} from 'quasar'
component.options.components = Object.assign({QItemLabel,QExpansionItem,QChip,QAvatar,QIcon,QItem,QCard,QToolbar,QToolbarTitle,QTooltip,QKnob,QCardSection,QTable,QTr,QTd}, component.options.components || {})
component.options.directives = Object.assign({Ripple}, component.options.directives || {})
